export const SET_GLOWFORGE_LANDING_PAGE = 'SET_GLOWFORGE_LANDING_PAGE';
export const SET_PROJECT_PICS = 'SET_PROJECT_PICS';



// WEBPACK FOOTER //
// ./app/actions/landing.js